export default "__VITE_PUBLIC_ASSET__d62a283d__"